import { render, staticRenderFns } from "./EnterTipsAudioWith.vue?vue&type=template&id=a8303734&scoped=true&"
import script from "./EnterTipsAudioWith.vue?vue&type=script&lang=js&"
export * from "./EnterTipsAudioWith.vue?vue&type=script&lang=js&"
import style0 from "./EnterTipsAudioWith.vue?vue&type=style&index=0&id=a8303734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8303734",
  null
  
)

export default component.exports